import React, { useContext } from "react";
import "./MostCommonWord.css";
import { AppContext } from "../../../../appContext";

interface IMostCommonWordProps {
    word: string;
    count: number;
}

export const MostCommonWord = ({word, count}: IMostCommonWordProps)=>{
    const { translate } = useContext(AppContext);
    
    return (
        <div className="mostCommonWord">
            <div className="mostCommonWord_head">
                {translate('most_common_word')}
            </div>
            <div className="mostCommonWord_word">
                {word}
            </div>
            <div className="mostCommonWord_used">
                {translate('used')}
                <span className="mostCommonWord_used_count">
                    {" "}{count} {translate('times')}{" "}
                </span>
                {translate('during_all_sessions')}
            </div>
        </div>
    )
}

interface IFirstCommonWordProps {
    word: string;
    name: string;
}

export const FirstCommonWord = ({word, name}: IFirstCommonWordProps)=>{
    const { translate } = useContext(AppContext);
    
    return (
        <div className="mostCommonWord">
            <div className="mostCommonWord_word">
                {word}
            </div>
            <div className="mostCommonWord_used">
                {name} {translate('used_word_today_first_time')}
            </div>
        </div>
    )
}